import apiClient from '../../apiClient';
import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { Box, Button } from '@mui/material';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { getStore } from '../../Store'
import { Tooltip } from '@material-ui/core';
const store = getStore();

const GenAlgRunTable = () => {
    const [genAlgRunResultsData, setGenAlgRunResultsData] = useState(undefined);

    useEffect(() => {
        SelectGenericFromTable("select * from gen_alg_run;", setGenAlgRunResultsData)
    }, []);

    const handleGenAlgRun = (id) => {
        store.updateStatusMessage("Triggering Genetic Algorithm Run...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Handle_Genetic_Algorithm_Run",
                "gen_alg_run_id": id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully triggered Genetic Algorithm Run!")
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Gen Alg Run")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while triggering Genetic Algorithm Run")
                }
            }
        })
    }

    const genAlgRunResultsColumns = [
        {
            field: 'actions',
            headerName: 'Actions',
            width: 90,
            renderCell: (params) => (
                <>
                    <Box sx={{ width: '200px' }}>
                        <Tooltip title="Trigger">
                            <Button
                                href="#"
                                onClick={() => handleGenAlgRun(params.row.id)}
                                style={{ minWidth: '35px', maxWidth: '35px', margin: '15px' }}
                            >
                                <ArrowForward />
                            </Button>
                        </Tooltip>
                    </Box>
                </>
            ),
        },
        {
            field: 'id',
            headerName: 'Gen Alg Run ID',
            width: 440,
            renderCell: (params) => (
                <>
                    {<a
                        href={'edit-gen-alg-run?id=' + params.row.id}
                    >
                        {params.row.id}
                    </a>}
                    {/*params.row.id*/}
                </>
            ),
        },
        {
            field: 'current_generation_number',
            headerName: 'Current Gen #',
            width: 120,
        },
        {
            field: 'partial_comparative_set_id',
            headerName: 'Comparative Set ID',
            width: 320,
            renderCell: (params) => (
                <>
                    {<a
                        href={'edit-comparative-set?id=' + params.row.partial_comparative_set_id}
                    >
                        {params.row.partial_comparative_set_id}
                    </a>}
                </>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 540,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let genAlgRunResultsDataRows = genAlgRunResultsData?.filter(data => data != null).map((genAlgRunResults) =>
    ({   
        id: genAlgRunResults.id,
        description: genAlgRunResults.description,
        current_generation_number: genAlgRunResults.current_generation_number,
        partial_comparative_set_id: genAlgRunResults.partial_comparative_set_id,
        created_date: genAlgRunResults.created_date
    }))


    if (genAlgRunResultsData === undefined) {
        return (<p>loading...</p>)
    }
    return (
        <DataGrid
            disableSelectionOnClick
            rows={genAlgRunResultsDataRows}
            columns={genAlgRunResultsColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }],
              },
            }}
            autoHeight
      />
    )
};

export { GenAlgRunTable };
